<template lang="pug">
.project-form__container
  h1.t-h1.title.clr-white {{title}}

  form(
    name="project-form"
    @submit.prevent="formSubmit"
      v-if="!isSuccess"
    ).project-form__inner.js-form.js-static-form
    .project-form__row
      component(
          v-for="item in fields"
          v-bind:is="getComponentByType(item.component)"
          v-model="updateField"
          :key="item.id"
          :item="item"
      )
    .project-form__row
      .project-form__checkbox
        input#project-form-agree(type="checkbox" checked name="project-form-agree" value="Y" required="")
        label(for="project-form-agree")
          | Отправляя заявку, я подтверждаю, что ознакомлен и согласен с&nbsp;
          a(href="/politika-konfidentsialnosti/" target="_blank") Политикой конфиденциальности
          |  данного сайта

      button.btn-submit.btn.bg-blue-18.clr-white(
          type=`submit`
          data-text submit
          data-success= success
          v-bind:class="{ active: isSuccess }"
      ) {{sendText}}
  .form-error(v-if="errors.length") Ошибка отправки
  .success-message.clr-white(v-if="isSuccess" v-html="successText")
</template>

<script>
  import plainform from './formlogic.js'
  export default plainform
</script>
